// Minimal accordion.js to toggle accordion sections

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.accordion');

  accordions.forEach(accordion => {
    const triggers = accordion.querySelectorAll('.accordion-trigger');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const content = trigger.nextElementSibling;
        const isOpen = content.classList.contains('is-open');

        if (isOpen) {
          content.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});
